export const REQUEST_DEFAULT_GIFT_CARD_BY_LOOK_KEY =
  'zola/overview/REQUEST_DEFAULT_GIFT_CARD_BY_LOOK_KEY';
export const RECEIVED_DEFAULT_GIFT_CARD_BY_LOOK_KEY =
  'zola/overview/RECEIVED_DEFAULT_GIFT_CARD_BY_LOOK_KEY';
export const REQUEST_PRODUCTS = 'zola/overview/REQUEST_PRODUCTS';
export const REQUEST_KITTED_PRODUCTS = 'zola/overview/REQUEST_KITTED_PRODUCTS';
export const RECEIVED_PRODUCTS = 'zola/overview/RECEIVED_PRODUCTS';
export const RECEIVED_KITTED_PRODUCTS = 'zola/overview/RECEIVED_KITTED_PRODUCTS';
